/**
 * sk-error
 * Used for displaying errors to the user. Usually from ajax calls to the server
 * E.g. Session Timeouts and
 */
bookingApp.directive('skError', function(){
    return {
        template: '<div class="error">' +
            '<div class="error-title"></div>' +
            '<div class="message"></div>' +
            '<button class="btn btn-primary col-xs-12" ng-click="closeErrorHandler()">Hide</button>' +
        '</div>',
        link: function(scope, element, attrs, controller){
            attrs.$observe('message', function(val){
                element.find('.error-title').html(attrs.errorTitle);
                element.find('.message').html(attrs.message);
            });
            attrs.$observe('error-title', function(val){
                element.find('.error-title').html(attrs.errorTitle);
                element.find('.message').html(attrs.message);
            });
            attrs.$observe('show', function(val){
                if(val !== false && val !== 'false'){
                    // remove initial hiding
                    element.removeClass('initial-hide');
                    // set the error title
                    element.find('.error-title').html(attrs.errorTitle);
                    // set the error message
                    element.find('.message').html(attrs.message);
                    // show the error
                    element.addClass('error-show');
                } else {
                    element.removeClass('error-show');
                }
            });
            // event handler for closing from within directive
            scope.closeErrorHandler = function(){
                scope.session.errorHandler.showError = false;
            }
        }
    }
});
bookingApp.directive('skPassiveError', function(){
    return {
        scope: {
            skPassiveError: '='
        },
        template: '<div>{{skPassiveError}}</div>'
    }
});